import "./Bio.css";
export default function Bio() {
  return (
    <div className="Bio" id="Bio">
      <div className="bioIntro">
        <h1>Jeet Trivedi</h1>
        <div>
          <h2>Rizvi College of Engineering</h2>
          <h2> - B.E(AI & DS)</h2>
        </div>
      </div>
      <div className="bioContent">
        Welcome to my Portfolio! With a hunger for creation and knack for
        programming I have set on a journey expressing myself through bytes in
        the software world. Below is both a testament and a transcription of my
        life in the world of development.
      </div>
    </div>
  );
}
